import { FormStyleContext } from "@common/contexts/FormStyle";
import { Common } from "@common/types";
import classnames from "classnames";
import React, { useContext } from "react";

import "./style.less";

export type ButtonsAlign = "left" | "right" | "center" | "justify" | "space_between";
export interface ButtonsContainerProps extends Common.WithChildren {
  align?: ButtonsAlign;
  className?: string;
  style?: React.CSSProperties;
}

const ButtonsContainer = (props: ButtonsContainerProps) => {
  const styleContext = useContext(FormStyleContext);
  const align = React.useMemo(() => {
    if (props.align) return props.align;
    if (styleContext.primaryButtonStyle) return styleContext?.buttonsAlign ?? "left"; // NEXT modules

    return "right";
  }, [styleContext?.buttonsAlign, props.align]);

  return (
    <div className={classnames("buttons", `align_${align}`, props.className)} style={props.style}>
      {props.children}
    </div>
  );
};

export default ButtonsContainer;
